import { Autocomplete, TextField } from '@mui/material'
import React, { useEffect } from 'react'
import { local } from 'service/api'
import { useStore } from 'store'
import { SelectProps } from './types'

export const SelectLocal: React.FC<SelectProps> = ({
    size = 'small',
    variant = 'filled',
    width,
    disabled,
}) => {
    const companyId = useStore(state => state.companyId)
    const { data = [] } = local.useFetch({
        queryParams: { empresaId: companyId },
    })

    const locationId = useStore(state => state.locationId)
    const setLocationId = useStore(state => state.setLocationId)

    useEffect(() => {
        if (locationId > 0 && !data.some(item => item.id === locationId)) {
            setLocationId(-1)
        }
    }, [data, locationId, setLocationId])

    const selectedLocal = data.find(item => item.id === locationId) ?? null

    return (
        <Autocomplete
            style={{ width }}
            options={data}
            value={selectedLocal}
            onChange={(_, value) => {
                setLocationId(value?.id ?? -1)
            }}
            getOptionLabel={option => option?.nomeLocal || ''}
            isOptionEqualToValue={(option, value) => option.id === value.id}
            disabled={disabled}
            renderInput={params => (
                <TextField
                    {...params}
                    name="localId"
                    label="Local"
                    size={size}
                    variant={variant}
                    fullWidth
                    InputLabelProps={{ shrink: true }}
                    placeholder="Selecione um local"
                    onKeyDownCapture={e => e.stopPropagation()}
                />
            )}
            noOptionsText={
                <span className="text-muted-foreground select-none">
                    Não há locais cadastrados
                </span>
            }
            clearIcon={null}
        />
    )
}
